<template>
    <div id="app">
        <router-view name="navigation" />
        <main class="site-content">
            <router-view :key="$route.path" />
        </main>
    </div>
</template>

<script>
export default {
    name: "app",
    data () {
        return {
        }
    },
    created() {
        this.$store.dispatch("fetchRemoteData");
        this.$store.dispatch("setWindowHeight");
        this.$store.dispatch("checkIfMobileNav");
        this.$store.dispatch("checkIfNotebook");
    },
    watch: {
        '$route' (to, from) {
            document.title = to.meta.title || 'PUMATRAC'
        }
    }
};
</script>

<style lang="scss">
#app {
    background: white;
}
</style>
